import React, { useState, useEffect } from 'react';
import './fees.css';
import './OneToOneAdd.css';
import './adduser.css';

const FeesAdd = () => {
  const [formData, setFormData] = useState({
    date: '',
    amount: '',
    mode: 'cash',
    type: 'joining-fee',
    user: '',
  });

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const response = await fetch(process.env.REACT_APP_SERVER_IP + '/api/admin/user', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          setUsers(data);
        } else {
          throw new Error('Failed to fetch users');
        }
      } catch (error) {
        console.error('Error fetching users:', error);
        setErrorMessage('Failed to fetch users');
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const formatLocalDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
    return d.toISOString().split('T')[0];
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const token = localStorage.getItem('token');
    if (!token || !formData.user) {
      alert('Authorization error or missing user.');
      return;
    }

    const submissionDate = new Date(formData.date).toISOString().split('T')[0];

    const data = {
      date: submissionDate,
      amount: formData.amount,
      mode: formData.mode,
      type: formData.type,
      user: formData.user,
    };

    try {
      const apiUrl = process.env.REACT_APP_SERVER_IP + '/api/admin/fee';
      setLoading(true);
      setErrorMessage('');

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      if (response.ok) {
        alert('Fees slip added successfully');
        setFormData({
          date: '',
          amount: '',
          mode: 'cash',
          type: 'joining-fee',
          user: '',
        });
      } else {
        setErrorMessage(result.message || 'An error occurred while adding the fee.');
        alert(result.message || 'An error occurred');
      }
    } catch (error) {
      console.error(error);
      setErrorMessage('An error occurred while submitting the form');
      alert('An error occurred while submitting the form');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contain">
      <main className="main-content">
        <div className="form-containerOne">
          <h2 className="name">Add Fees</h2>

          <form id="useForm" onSubmit={handleSubmit}>
            <div className="form-group1">
              <input
                type="date"
                id="date"
                name="date"
                placeholder="Date"
                value={formData.date}
                onChange={handleChange}
                required
                max={new Date().toISOString().split('T')[0]}
              />
            </div>

            <div>
              <select
                id="user"
                name="user"
                value={formData.user}
                onChange={handleChange}
                className="form-group11"
                required
              >
                <option value="">Select User</option>
                {loading ? (
                  <option>Loading...</option>
                ) : (
                  users.map((user) => {
                    const userName =
                      user.firstName && user.lastName
                        ? `${user.firstName} ${user.lastName}`
                        : 'Unknown';
                    return (
                      <option key={user._id} value={user._id}>
                        {userName}
                      </option>
                    );
                  })
                )}
              </select>
            </div>

            <div className="form-group1">
              <input
                type="number"
                id="amount"
                name="amount"
                placeholder="Amount"
                value={formData.amount}
                onChange={handleChange}
                required
              />
            </div>

            <div className="radio-sectionn">
              <label className="section-labell">Type of fees :-</label>
              <div className="radio-optionss">
                <label>
                  <input
                    type="radio"
                    name="type"
                    value="joining-fee"
                    checked={formData.type === 'joining-fee'}
                    onChange={handleChange}
                  />
                  Yearly Joining Fees
                </label>
                <label>
                  <input
                    type="radio"
                    name="type"
                    value="meeting-fee"
                    checked={formData.type === 'meeting-fee'}
                    onChange={handleChange}
                  />
                  Ahmedabad University
                </label>
              </div>
            </div>

            <div className="radio-sectionn">
              <label className="section-labell">Payment Mode :-</label>
              <div className="radio-optionss">
                <label>
                  <input
                    type="radio"
                    name="mode"
                    value="cash"
                    checked={formData.mode === 'cash'}
                    onChange={handleChange}
                  />
                  Cash
                </label>
                <label>
                  <input
                    type="radio"
                    name="mode"
                    value="cheque"
                    checked={formData.mode === 'cheque'}
                    onChange={handleChange}
                  />
                  Cheque
                </label>
                <label>
                  <input
                    type="radio"
                    name="mode"
                    value="online"
                    checked={formData.mode === 'online'}
                    onChange={handleChange}
                  />
                  Online
                </label>
              </div>
            </div>

            <button type="submit" className="update-detailsAdd">
              Add Fee
            </button>
          </form>
        </div>
      </main>
    </div>
  );
};

export default FeesAdd;
